import { render } from "./detailsNombre.vue?vue&type=template&id=51f69f21&scoped=true"
import script from "./detailsNombre.vue?vue&type=script&lang=js"
export * from "./detailsNombre.vue?vue&type=script&lang=js"

import "./detailsNombre.vue?vue&type=style&index=0&id=51f69f21&lang=scss&scoped=true"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f69f21"]])

export default __exports__